/*
  Filtering for sections/pf-catalog.liquid (the Roland DG category pages).

  Everything the page needs is already in the DOM as data attributes, so this
  file never fetches. State per page:
    filters  { key: [value, ...] }   multi-select, empty group = no constraint
    machine  slug | null             single-select chip, re-click clears
    query    string                  parts only; matches name + part numbers
    sort     'featured' | 'low' | 'high'

  Two rules from the design handoff that matter more than the rest:
  1. Sidebar counts are cross-filtered: an option's count reflects every other
     active filter, computed against a pool that excludes its own group.
  2. An item whose compatibility is unknown never passes the machine filter.
     It moves to the "we can check for you" block instead, and the result
     counter says so ("4 parts for the GS2-24, plus 6 to confirm").
*/
(function () {
  'use strict';

  function init(root) {
    var mode = root.getAttribute('data-mode');
    var noun = root.getAttribute('data-noun') || 'products';
    var nounOne = root.getAttribute('data-noun-one') || 'product';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-pf-item]'));
    // Cards carry data-pf-group too; only the <section> wrappers are groups.
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-pf-group]:not([data-pf-item])'));
    var fgroups = Array.prototype.slice.call(root.querySelectorAll('[data-pf-fgroup]'));
    // Collapsible group wrappers; absent unless the section opted in.
    var folds = Array.prototype.slice.call(root.querySelectorAll('[data-pf-fold]'));
    var foldAll = root.querySelector('[data-pf-foldall]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-pf-machine]'));
    var q = root.querySelector('[data-pf-q]');
    var rcount = root.querySelector('[data-pf-rcount]');
    var empty = root.querySelector('[data-pf-empty]');
    var unconf = root.querySelector('[data-pf-unconfirmed]');
    var unconfList = root.querySelector('[data-pf-unconfirmed-list]');
    var unconfHead = root.querySelector('[data-pf-unconfirmed-heading]');
    var unconfNote = root.querySelector('[data-pf-unconfirmed-note]');
    var pickerNote = root.querySelector('[data-pf-picker-note]');
    var pickerClear = root.querySelector('[data-pf-picker-clear]');
    var clearBtn = root.querySelector('[data-pf-clear]');

    var state = { filters: {}, machine: null, machineLabel: '', machineNote: '', query: '', sort: 'featured' };

    // Remember each item's home group so unconfirmed items can be moved and returned.
    items.forEach(function (el) { el._home = el.parentNode; });

    function data(el) {
      if (el._d) return el._d;
      var d = {
        group: el.getAttribute('data-pf-group') || '',
        format: el.getAttribute('data-pf-format') || '',
        use: (el.getAttribute('data-pf-use') || '').split(/\s+/).filter(Boolean),
        fits: (el.getAttribute('data-pf-fits') || '').split(/\s+/).filter(Boolean),
        confirmed: el.getAttribute('data-pf-confirmed') === 'yes',
        avail: el.getAttribute('data-pf-avail') || 'instock',
        price: parseInt(el.getAttribute('data-pf-price') || '0', 10),
        search: (el.getAttribute('data-pf-search') || '').toLowerCase(),
        pos: parseInt(el.getAttribute('data-pf-pos') || '0', 10),
        rank: parseInt(el.getAttribute('data-pf-rank') || '99', 10)
      };
      el._d = d;
      return d;
    }

    // ---- matching ----------------------------------------------------------
    // Budget ranges are authored in the store currency (USD). Shopify Markets
    // shows Canadian visitors CAD, and data-pf-price is in that presentment
    // currency, so convert each threshold with the active rate and round it
    // to a clean figure. The option label is rewritten to the same rounded
    // figure so what the visitor reads is what the filter does.
    var RATE = 1;
    try { RATE = parseFloat(window.Shopify.currency.rate) || 1; } catch (e) { /* no Markets data: store currency */ }
    function roundMoney(n) { return n >= 5000 ? Math.round(n / 1000) * 1000 : Math.round(n / 100) * 100; }
    function fmtMoney(n) { return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function ranges() {
      var r = {};
      root.querySelectorAll('[data-pf-range]').forEach(function (i) {
        var bounds = i.getAttribute('data-pf-range').split('-').map(Number).map(function (n) { return n ? roundMoney(n * RATE) : 0; });
        r[i.getAttribute('data-pf-opt')] = bounds;
        if (RATE !== 1) {
          var label = i.parentNode.querySelector('.pf-cat-opt-label');
          var vals = [bounds[0], bounds[1]].filter(Boolean), k = 0;
          if (label) label.textContent = label.textContent.replace(/\$[\d,]+/g, function (m) { return k < vals.length ? fmtMoney(vals[k++]) : m; });
        }
      });
      return r;
    }
    var RANGES = ranges();

    function matchKey(d, key, values) {
      if (!values || !values.length) return true;
      if (key === 'budget') {
        return values.some(function (v) {
          var r = RANGES[v]; if (!r) return true;
          var dollars = d.price / 100;
          return dollars >= r[0] && (r[1] === 0 || dollars < r[1]);
        });
      }
      if (key === 'availability') return values.indexOf(d.avail) !== -1;
      if (key === 'use') return d.use.some(function (u) { return values.indexOf(u) !== -1; });
      if (key === 'format') return values.indexOf(d.format) !== -1;
      // group and type both live in data-pf-group
      return values.indexOf(d.group) !== -1;
    }
    function matchMachine(d) {
      if (!state.machine) return true;
      return d.confirmed && d.fits.indexOf(state.machine) !== -1;
    }
    function matchQuery(d) {
      if (!state.query) return true;
      var terms = state.query.toLowerCase().replace(/[-\s]+/g, ' ').trim().split(' ');
      var hay = d.search.replace(/[-\s]+/g, ' ');
      return terms.every(function (t) { return hay.indexOf(t) !== -1; });
    }
    function passesFilters(d, exceptKey) {
      return fgroups.every(function (g) {
        var key = g.getAttribute('data-pf-fgroup');
        if (key === exceptKey) return true;
        return matchKey(d, key, state.filters[key]);
      });
    }

    // ---- collapsible groups -------------------------------------------------
    // The default open/shut state follows intent, not the last click: shut while
    // you are browsing the whole catalogue, open the moment a search or machine
    // narrows it, because then the rows ARE the answer. `lastNarrowed` means we
    // only overwrite the folds when that intent flips, so a group you opened by
    // hand stays open while you keep browsing.
    var lastNarrowed = null;

    function foldPinned(f) { return f.hasAttribute('data-pf-fold-open'); }
    function foldVisible(f) {
      var sec = f.parentNode;
      while (sec && !sec.classList.contains('pf-cat-group')) sec = sec.parentNode;
      return !(sec && sec.hidden);
    }
    function setFolds(open) {
      folds.forEach(function (f) { f.open = foldPinned(f) ? true : open; });
      syncFoldAll();
    }
    function syncFoldAll() {
      if (!foldAll) return;
      var live = folds.filter(function (f) { return !foldPinned(f) && foldVisible(f); });
      var allOpen = live.length > 0 && live.every(function (f) { return f.open; });
      foldAll.textContent = allOpen ? 'Collapse all' : 'Expand all';
      foldAll.setAttribute('aria-expanded', allOpen ? 'true' : 'false');
      foldAll.hidden = live.length === 0;
    }

    // ---- render ------------------------------------------------------------
    function render() {
      var shown = [], toConfirm = [];
      items.forEach(function (el) {
        var d = data(el);
        var base = matchQuery(d) && passesFilters(d, null);
        if (!base) { el.hidden = true; return; }
        if (state.machine && !d.confirmed) { toConfirm.push(el); el.hidden = false; return; }
        if (!matchMachine(d)) { el.hidden = true; return; }
        el.hidden = false; shown.push(el);
      });

      // Put every item back home, then move the to-confirm ones out.
      items.forEach(function (el) { if (el.parentNode !== el._home) el._home.appendChild(el); });
      if (unconfList) toConfirm.forEach(function (el) { unconfList.appendChild(el); });

      // Sort within each list.
      var lists = Array.prototype.slice.call(root.querySelectorAll('[data-pf-list], [data-pf-unconfirmed-list]'));
      lists.forEach(function (list) {
        var kids = Array.prototype.slice.call(list.children).filter(function (el) { return el.hasAttribute('data-pf-item'); });
        kids.sort(function (a, b) {
          var da = data(a), db = data(b);
          if (state.sort === 'low') return da.price - db.price;
          if (state.sort === 'high') return db.price - da.price;
          // Featured: the group's own keyword order first, collection order within it.
          if (da.rank !== db.rank) return da.rank - db.rank;
          return da.pos - db.pos;
        });
        kids.forEach(function (el) { list.appendChild(el); });
      });

      // Group visibility + counts.
      groups.forEach(function (g) {
        var visible = Array.prototype.slice.call(g.querySelectorAll('[data-pf-item]')).filter(function (el) { return !el.hidden; });
        g.hidden = visible.length === 0;
        var c = g.querySelector('[data-pf-gcount]');
        if (c) c.textContent = visible.length + ' ' + (visible.length === 1 ? nounOne : noun);
      });
      if (unconf) {
        unconf.hidden = toConfirm.length === 0;
        if (unconfHead) unconfHead.textContent = toConfirm.length + ' more ' + (toConfirm.length === 1 ? nounOne : noun) + ' we can check for you';
        if (unconfNote) unconfNote.textContent = 'We have not yet confirmed whether these fit the ' + state.machineLabel + '. Send us your model and we will verify before you order.';
      }

      // Fit labels on rows/cards. Machines have nothing to "fit", so the
      // machines page never shows a compatibility line.
      items.forEach(function (el) {
        var d = data(el);
        var fl = el.querySelector('[data-pf-fitslabel], [data-pf-fitnote]');
        if (!fl || mode === 'machines') return;
        if (!d.confirmed) { fl.textContent = 'Compatibility: confirm with us'; fl.classList.add('is-unconfirmed'); }
        else if (state.machine) { fl.textContent = 'Fits the ' + state.machineLabel; fl.classList.remove('is-unconfirmed'); }
        else { fl.textContent = ''; fl.classList.remove('is-unconfirmed'); }
      });

      // Result counter.
      var n = shown.length, total = items.length;
      var word = n === 1 ? nounOne : noun;
      var text;
      if (state.machine) {
        text = n + ' ' + word + ' for the ' + state.machineLabel + (toConfirm.length ? ', plus ' + toConfirm.length + ' to confirm' : '');
      } else if (n === total) {
        text = total + ' ' + (total === 1 ? nounOne : noun);
      } else {
        text = n + ' of ' + total + ' ' + noun;
      }
      if (rcount) rcount.textContent = text;
      if (empty) empty.hidden = !(n === 0 && toConfirm.length === 0);

      // Cross-filtered counts in the sidebar.
      fgroups.forEach(function (g) {
        var key = g.getAttribute('data-pf-fgroup');
        var pool = items.filter(function (el) {
          var d = data(el);
          return matchQuery(d) && matchMachine(d) && passesFilters(d, key);
        });
        g.querySelectorAll('[data-pf-opt]').forEach(function (input) {
          var v = input.getAttribute('data-pf-opt');
          var c = pool.filter(function (el) { return matchKey(data(el), key, [v]); }).length;
          var out = input.parentNode.querySelector('[data-pf-count]');
          if (out) out.textContent = c;
          input.parentNode.classList.toggle('is-zero', c === 0 && !input.checked);
        });
      });

      var anyFilter = Object.keys(state.filters).some(function (k) { return state.filters[k] && state.filters[k].length; });
      if (clearBtn) clearBtn.hidden = !anyFilter;

      if (folds.length) {
        var narrowed = !!(state.query || state.machine || anyFilter);
        if (narrowed !== lastNarrowed) { lastNarrowed = narrowed; setFolds(narrowed); }
        else syncFoldAll();
      }
      syncUrl();
      if (pickerClear) pickerClear.hidden = !state.machine;
      if (pickerNote) { pickerNote.hidden = !(state.machine && state.machineNote); pickerNote.textContent = state.machineNote || ''; }
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-pf-machine') === state.machine ? 'true' : 'false'); });
      var qc = root.querySelector('[data-pf-clear-q]'); if (qc) qc.hidden = !state.query;
    }

    // Keep ?machine= in the address bar so a chosen machine survives a reload
    // and can be shared or linked from a machine page. replaceState, not push:
    // the chips are a filter, not navigation, so Back should leave the page.
    function syncUrl() {
      if (!window.history || !window.history.replaceState || !window.URL) return;
      try {
        var u = new URL(window.location.href);
        if (state.machine) u.searchParams.set('machine', state.machine);
        else u.searchParams.delete('machine');
        window.history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
      } catch (e) { /* older browser: the filter still works, just not the URL */ }
    }

    // ---- events ------------------------------------------------------------
    root.querySelectorAll('[data-pf-opt]').forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.closest('[data-pf-fgroup]').getAttribute('data-pf-fgroup');
        var v = input.getAttribute('data-pf-opt');
        var cur = state.filters[key] || [];
        state.filters[key] = input.checked ? cur.concat([v]) : cur.filter(function (x) { return x !== v; });
        render();
      });
    });
    function clearFilters() {
      state.filters = {};
      root.querySelectorAll('[data-pf-opt]').forEach(function (i) { i.checked = false; });
    }
    if (clearBtn) clearBtn.addEventListener('click', function () { clearFilters(); render(); });
    root.querySelectorAll('[data-pf-clear-all]').forEach(function (b) {
      b.addEventListener('click', function () {
        clearFilters(); state.machine = null; state.machineLabel = ''; state.machineNote = ''; state.query = '';
        if (q) q.value = '';
        render();
      });
    });
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var slug = c.getAttribute('data-pf-machine');
        if (state.machine === slug) { state.machine = null; state.machineLabel = ''; state.machineNote = ''; }
        else { state.machine = slug; state.machineLabel = c.textContent.trim(); state.machineNote = c.getAttribute('data-pf-note') || ''; }
        render();
      });
    });
    if (pickerClear) pickerClear.addEventListener('click', function () { state.machine = null; state.machineLabel = ''; state.machineNote = ''; render(); });
    var lt = root.querySelector('[data-pf-legacy-toggle]'), lb = root.querySelector('[data-pf-legacy]');
    if (lt && lb) lt.addEventListener('click', function () {
      var open = lb.hidden; lb.hidden = !open;
      lt.setAttribute('aria-expanded', open ? 'true' : 'false');
      lt.textContent = open ? 'Hide legacy machines' : 'Show legacy machines';
    });
    root.querySelectorAll('[data-pf-sort]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.sort = b.getAttribute('data-pf-sort');
        root.querySelectorAll('[data-pf-sort]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        render();
      });
    });
    if (q) {
      var t;
      q.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { state.query = q.value.trim(); render(); }, 120); });
      var qc = root.querySelector('[data-pf-clear-q]');
      if (qc) qc.addEventListener('click', function () { q.value = ''; state.query = ''; render(); q.focus(); });
    }

    // Deep link: ?machine=slug preselects a chip (machine pages link here).
    try {
      var want = new URL(window.location.href).searchParams.get('machine');
      if (want) chips.some(function (c) {
        if (c.getAttribute('data-pf-machine') === want) {
          state.machine = want; state.machineLabel = c.textContent.trim(); state.machineNote = c.getAttribute('data-pf-note') || '';
          if (c.hasAttribute('data-pf-legacy-machine') && lt) lt.click();
          return true;
        }
        return false;
      });
    } catch (e) { /* no URL API: skip the deep link */ }

    folds.forEach(function (f) { f.addEventListener('toggle', syncFoldAll); });
    if (foldAll) {
      foldAll.addEventListener('click', function () {
        setFolds(foldAll.getAttribute('aria-expanded') !== 'true');
      });
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-pf-catalog]').forEach(init); }
  // Machine picker arrows: scroll the chip row by most of its width, and grey
  // out an arrow when there is nothing further that way.
  function bootScrollers() {
    document.querySelectorAll('[data-pf-picker]').forEach(function (picker) {
      var row = picker.querySelector('[data-pf-scroller]');
      var arrows = picker.querySelectorAll('[data-pf-scroll]');
      if (!row || !arrows.length) return;
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        arrows.forEach(function (a) {
          a.disabled = a.getAttribute('data-pf-scroll') === '-1' ? row.scrollLeft <= 2 : row.scrollLeft >= max;
        });
        row.classList.toggle('is-end', row.scrollLeft >= max);
        var none = max <= 0;
        arrows.forEach(function (a) { a.hidden = none; });
      }
      arrows.forEach(function (a) {
        a.addEventListener('click', function () {
          row.scrollBy({ left: +a.getAttribute('data-pf-scroll') * row.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); bootScrollers(); }); else { boot(); bootScrollers(); }
})();
